const projectsData = [
  {
    clickable: true,
    src: "spacial_office.jpg",
    title: "SP10_Office",
    redirect: "SP10_Office",
    description: [
      `project_office` ,
    ],
    category: 'Commercial',
    location: 'Kolonaki_athens',
    photoBy: `myrto`,
    images: [
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/00.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/01.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/02.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/03.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/04.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/05.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/06.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/07.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/08.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/09.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/10.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/11.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/12.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/13.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/14.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/15.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/16.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/17.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/18.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/19.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/20.jpg", title: "sp_office" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/01_SP_OFFICE/21.jpg", title: "sp_office" },
    ],
  },
  {
    clickable: true,
    src: "cine.png",
    title: "Cine Paris",
    category: 'Commercial',
    description: [
      `project_cine` ,
    ],
    redirect: "Cine_Paris",
    location: "Plaka_athens",
    photoBy: `Spatial`,
    images: [
      { src: "/SITE_PROJECTS/03_COMMERCIAL/02_CINE_PARIS/COLLAGES/COLLAGE1.jpg", title: "Cine Paris" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/02_CINE_PARIS/COLLAGES/COLLAGE2.jpg", title: "Cine Paris" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/02_CINE_PARIS/PHOTOS/1.jpg", title: "Cine Paris" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/02_CINE_PARIS/PHOTOS/2.jpg", title: "Cine Paris" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/02_CINE_PARIS/PHOTOS/3.jpg", title: "Cine Paris" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/02_CINE_PARIS/PHOTOS/4.jpg", title: "Cine Paris" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/02_CINE_PARIS/PHOTOS/5.jpg", title: "Cine Paris" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/02_CINE_PARIS/PHOTOS/6.jpg", title: "Cine Paris" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/02_CINE_PARIS/PHOTOS/7.jpg", title: "Cine Paris" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/02_CINE_PARIS/PHOTOS/8.jpg", title: "Cine Paris" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/02_CINE_PARIS/PHOTOS/9.jpg", title: "Cine Paris" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/02_CINE_PARIS/PHOTOS/10.jpg", title: "Cine Paris" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/02_CINE_PARIS/RENDERS/1.jpg", title: "Cine Paris" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/02_CINE_PARIS/RENDERS/2.jpg", title: "Cine Paris" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/02_CINE_PARIS/RENDERS/3.jpg", title: "Cine Paris" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/02_CINE_PARIS/RENDERS/4.jpg", title: "Cine Paris" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/02_CINE_PARIS/RENDERS/5.jpg", title: "Cine Paris" },
    ],
  },
  { clickable: true,
    src: "/SITE_PROJECTS/01_RESIDENTIAL/01_VATOS/VATOS_2.jpg", 
    title: "Vatos", 
    redirect: "Vatos",
    category: 'Residential',
    description: ['Vatos_desc'],
    location: 'Vatos_corfu',
    info: 'Vatos_corfu_info',
    images: [
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/01_VATOS/VATOS_1.jpg", title: "Vatos" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/01_VATOS/VATOS_2.jpg", title: "Vatos" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/01_VATOS/VATOS_3.jpg", title: "Vatos" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/01_VATOS/VATOS_4.jpg", title: "Vatos" },
    ],
   },
   { clickable: true,
    src: "/SITE_PROJECTS/01_RESIDENTIAL/02_VILLA_WING/VILLA_WING_1.jpg", 
    title: "Villa Wing", 
    redirect: "Villa_wing",
    category: 'Residential',
    description: ['Villa_wing'],
    location: 'Pentati_Corfu',
    info: 'VIlla_wing_info',
    images: [
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/02_VILLA_WING/VILLA_WING_1.jpg", title: "Villa_wing" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/02_VILLA_WING/VILLA_WING_2.jpg", title: "Villa_wing" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/02_VILLA_WING/VILLA_WING_3.jpg", title: "Villa_wing" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/02_VILLA_WING/VILLA_WING_4.jpg", title: "Villa_wing" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/02_VILLA_WING/VILLA_WING_5.jpg", title: "Villa_wing" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/02_VILLA_WING/VILLA_WING_6.jpg", title: "Villa_wing" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/02_VILLA_WING/VILLA_WING_7.jpg", title: "Villa_wing" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/02_VILLA_WING/VILLA_WING_8.jpg", title: "Villa_wing" }
    ],
   },
   { clickable: true,
    src: "/SITE_PROJECTS/01_RESIDENTIAL/03_VILLA_MIES/VILLA_MIES_1.jpg", 
    title: "Villa Mies", 
    redirect: "Villa_mies",
    category: 'Residential',
    description: ['Villa_mies'],
    location: 'Pentati_Corfu',
    info: 'Pentati_corfu_info',
    images: [
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/03_VILLA_MIES/VILLA_MIES_1.jpg", title: "VILLA_MIES" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/03_VILLA_MIES/VILLA_MIES_2.jpg", title: "VILLA_MIES" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/03_VILLA_MIES/VILLA_MIES_3.jpg", title: "VILLA_MIES" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/03_VILLA_MIES/VILLA_MIES_4.jpg", title: "VILLA_MIES" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/03_VILLA_MIES/VILLA_MIES_5.jpg", title: "VILLA_MIES" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/03_VILLA_MIES/VILLA_MIES_6.jpg", title: "VILLA_MIES" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/03_VILLA_MIES/VILLA_MIES_7.jpg", title: "VILLA_MIES" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/03_VILLA_MIES/VILLA_MIES_8.jpg", title: "VILLA_MIES" }
    ],
   },
   { clickable: true,
    src: "/SITE_PROJECTS/01_RESIDENTIAL/04_VILLA_ROUND/VILLA_ROUND_1.jpg", 
    title: "Villa Round", 
    category: 'Residential',
    redirect: "Villa_round",
    description: ['Villa_round'],
    location: 'Pentati_Corfu',
    info: 'Pentati_corfu_info',
    images: [
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/04_VILLA_ROUND/VILLA_ROUND_1.jpg", title: "VILLA_ROUND" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/04_VILLA_ROUND/VILLA_ROUND_2.jpg", title: "VILLA_ROUND" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/04_VILLA_ROUND/VILLA_ROUND_3.jpg", title: "VILLA_ROUND" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/04_VILLA_ROUND/VILLA_ROUND_5.jpg", title: "VILLA_ROUND" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/04_VILLA_ROUND/VILLA_ROUND_6.jpg", title: "VILLA_ROUND" }
    ],
   },
   { clickable: true,
    src: "/SITE_PROJECTS/01_RESIDENTIAL/05_VILLA_KORAKIANA/VILLA_KORAKIANA_1.jpg", 
    title: "Korakiana", 
    redirect: "Villa_korakiana",
    description: ['Korakiana_desc'],
    category: 'Residential',
    location: 'Pentati_Corfu',
    info: 'Pentati_corfu_info',
    images: [
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/05_VILLA_KORAKIANA/VILLA_KORAKIANA_1.jpg", title: "VILLA_KORAKIANA" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/05_VILLA_KORAKIANA/VILLA_KORAKIANA_2.jpg", title: "VILLA_KORAKIANA" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/05_VILLA_KORAKIANA/VILLA_KORAKIANA_3.jpg", title: "VILLA_KORAKIANA" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/05_VILLA_KORAKIANA/VILLA_KORAKIANA_4.jpg", title: "VILLA_KORAKIANA" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/05_VILLA_KORAKIANA/VILLA_KORAKIANA_5.jpg", title: "VILLA_KORAKIANA" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/05_VILLA_KORAKIANA/VILLA_KORAKIANA_6.jpg", title: "VILLA_KORAKIANA" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/05_VILLA_KORAKIANA/VILLA_KORAKIANA_7.jpg", title: "VILLA_KORAKIANA" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/05_VILLA_KORAKIANA/VILLA_KORAKIANA_8.jpg", title: "VILLA_KORAKIANA" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/05_VILLA_KORAKIANA/VILLA_KORAKIANA_9.jpg", title: "VILLA_KORAKIANA" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/05_VILLA_KORAKIANA/VILLA_KORAKIANA_10.jpg", title: "VILLA_KORAKIANA" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/05_VILLA_KORAKIANA/VILLA_KORAKIANA_11.jpg", title: "VILLA_KORAKIANA" }
    ],
   },
   { clickable: true,
    src: "/SITE_PROJECTS/01_RESIDENTIAL/06_VILLA_GLYFADA/VILLA_GLYFADA_1.jpg", 
    title: "Glyfada", 
    redirect: "VILLA_GLYFADA",
    description: ['Glyfada_desc'],
    category: 'Residential',
    location: 'Pentati_Corfu',
    info: 'Pentati_corfu_info',
    images: [
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/06_VILLA_GLYFADA/VILLA_GLYFADA_1.jpg", title: "VILLA_GLYFADA" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/06_VILLA_GLYFADA/VILLA_GLYFADA_2.jpg", title: "VILLA_GLYFADA" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/06_VILLA_GLYFADA/VILLA_GLYFADA_3.jpg", title: "VILLA_GLYFADA" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/06_VILLA_GLYFADA/VILLA_GLYFADA_4.jpg", title: "VILLA_GLYFADA" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/06_VILLA_GLYFADA/VILLA_GLYFADA_5.jpg", title: "VILLA_GLYFADA" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/06_VILLA_GLYFADA/VILLA_GLYFADA_7.jpg", title: "VILLA_GLYFADA" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/06_VILLA_GLYFADA/VILLA_GLYFADA_8.jpg", title: "VILLA_GLYFADA" }
    ],
   },   
   { clickable: true,
    src: "farmhouse.png",
    title: "Corfu Farmhouse",
    redirect: "Corfu_Farmhouse",
    description: ['Corfu_Farmhouse'],
    location: 'Solari_corfu',
    category: 'Residential',
    info: 'Solari_corfu_info',
    images: [
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/07_CORFU_FARMHOUSE/CORFU_FARMHOUSE_1.jpg", title: "Corfu Farmhouse" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/07_CORFU_FARMHOUSE/CORFU_FARMHOUSE_2.jpg", title: "Corfu Farmhouse" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/07_CORFU_FARMHOUSE/CORFU_FARMHOUSE_4.jpg", title: "Corfu Farmhouse" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/07_CORFU_FARMHOUSE/CORFU_FARMHOUSE_3.jpg", title: "Corfu Farmhouse" },
    ],
   },
   { src: "lux_kitchen.jpg",
     title: "Concept Villa 01", 
     clickable: true, 
     category: 'Residential',
     redirect: "Concept_Villa_01",
     description: ['Concept_villa_01'],
     location: 'Kommeno_corfu',
    info: 'Kommeno_corfu_info',
    images: [
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/08_CONCEPT_VILLA_01/CONCEPT_VILLA_01_1.jpg", title: "Concept_Villa_01" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/08_CONCEPT_VILLA_01/CONCEPT_VILLA_01_2.jpg", title: "Concept_Villa_01" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/08_CONCEPT_VILLA_01/CONCEPT_VILLA_01_4.jpg", title: "Concept_Villa_01" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/08_CONCEPT_VILLA_01/CONCEPT_VILLA_01_3.jpg", title: "Concept_Villa_01" },
    ]
    
   },
   { 
    src: "/SITE_PROJECTS/01_RESIDENTIAL/09_CONCEPT_VILLA_02/CONCEPT_VILLA_02_01.jpg",
    title: "Concept Villa 02",
    clickable: true,
    category: 'Residential',
    redirect: "Concept_Villa_02",
    description: ['Concept_villa_02'],
    location: 'Kommeno_corfu',
    info: 'Kommeno_corfu_info',
    images: [
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/09_CONCEPT_VILLA_02/CONCEPT_VILLA_02_01.jpg", title: "Concept_Villa_02" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/09_CONCEPT_VILLA_02/CONCEPT_VILLA_02_02.jpg", title: "Concept_Villa_02" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/09_CONCEPT_VILLA_02/CONCEPT_VILLA_02_03.jpg", title: "Concept_Villa_02" },
    ]
   },
   { clickable: true,
    src: "/SITE_PROJECTS/01_RESIDENTIAL/10_PAXOI/PAXOI_6.jpg", 
    title: "Paxoi", 
    redirect: "PAXOI",
    category: 'Residential',
    description: ['Paxoi_desc1','Paxoi_desc2'],
    location: 'Dendiatika_paxoi',
    info: 'Dendiatika_paxoi_info',
    images: [
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/10_PAXOI/PAXOI_1.gif", title: "PAXOI" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/10_PAXOI/PAXOI_2.jpg", title: "PAXOI" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/10_PAXOI/PAXOI_3.jpg", title: "PAXOI" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/10_PAXOI/PAXOI_4.jpg", title: "PAXOI" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/10_PAXOI/PAXOI_5.jpg", title: "PAXOI" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/10_PAXOI/PAXOI_6.jpg", title: "PAXOI" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/10_PAXOI/PAXOI_7.jpg", title: "PAXOI" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/10_PAXOI/PAXOI_8.jpg", title: "PAXOI" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/10_PAXOI/PAXOI_9.jpg", title: "PAXOI" }
    ],
   },
   { clickable: true,
    src: "/SITE_PROJECTS/02_HOSPITALITY/01_CORFU_ATTIC_APARTMENTS/CORFU_ATTIC_1.jpg", 
    title: "Corfu Attic Apartments", 
    redirect: "CORFU_ATTIC",
    description: ['corfu_attic'],
    location: 'Old_town_corfu',
    info: 'Old_town_corfu_info',
    category: 'Hospitality',
    images: [
      { src: "/SITE_PROJECTS/02_HOSPITALITY/01_CORFU_ATTIC_APARTMENTS/CORFU_ATTIC_1.jpg", title: "CORFU_ATTIC" },
      { src: "/SITE_PROJECTS/02_HOSPITALITY/01_CORFU_ATTIC_APARTMENTS/CORFU_ATTIC_2.jpg", title: "CORFU_ATTIC" },
      { src: "/SITE_PROJECTS/02_HOSPITALITY/01_CORFU_ATTIC_APARTMENTS/CORFU_ATTIC_3.jpg", title: "CORFU_ATTIC" },
      { src: "/SITE_PROJECTS/02_HOSPITALITY/01_CORFU_ATTIC_APARTMENTS/CORFU_ATTIC_4.jpg", title: "CORFU_ATTIC" },
      { src: "/SITE_PROJECTS/02_HOSPITALITY/01_CORFU_ATTIC_APARTMENTS/CORFU_ATTIC_5.jpg", title: "CORFU_ATTIC" },
      { src: "/SITE_PROJECTS/02_HOSPITALITY/01_CORFU_ATTIC_APARTMENTS/CORFU_ATTIC_6.jpg", title: "CORFU_ATTIC" },
      { src: "/SITE_PROJECTS/02_HOSPITALITY/01_CORFU_ATTIC_APARTMENTS/CORFU_ATTIC_7.jpg", title: "CORFU_ATTIC" }
    ],
   },
   { clickable: true,
    src: "/SITE_PROJECTS/02_HOSPITALITY/02_OLD_TOWN_BOUTIQUE_HOTEL/OLD_TOWN_1.jpg", 
    title: "Old Town Boutique Hotel", 
    redirect: "OLD_TOWN",
    description: ['old_town'],
    category: 'Hospitality',
    location: 'Old_town_corfu',
    info: 'Old_town_corfu_info',
    images: [
      { src: "/SITE_PROJECTS/02_HOSPITALITY/02_OLD_TOWN_BOUTIQUE_HOTEL/OLD_TOWN_1.jpg", title: "OLD_TOWN" },
      { src: "/SITE_PROJECTS/02_HOSPITALITY/02_OLD_TOWN_BOUTIQUE_HOTEL/OLD_TOWN_2.jpg", title: "OLD_TOWN" },
      { src: "/SITE_PROJECTS/02_HOSPITALITY/02_OLD_TOWN_BOUTIQUE_HOTEL/OLD_TOWN_3.jpg", title: "OLD_TOWN" },
      { src: "/SITE_PROJECTS/02_HOSPITALITY/02_OLD_TOWN_BOUTIQUE_HOTEL/OLD_TOWN_4.jpg", title: "OLD_TOWN" }
    ],
   },
   { clickable: true,
    src:  "/SITE_PROJECTS/03_COMMERCIAL/03_DENTIST_OFFICE/1.jpg",
    title: "Dentist's office",
    category: 'Commercial',
    redirect: "DENTIST_OFFICE",
    description: [`dentist_office` ],
    location: 'Neos_kosmos',
    info: 'Neos_kosmos_info',
    photoBy: "Spatial Architecture + Design",
    images: [
      { src: "/SITE_PROJECTS/03_COMMERCIAL/03_DENTIST_OFFICE/1.jpg", title: "DENTIST_OFFICE" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/03_DENTIST_OFFICE/2.jpg", title: "DENTIST_OFFICE" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/03_DENTIST_OFFICE/3.jpg", title: "DENTIST_OFFICE" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/03_DENTIST_OFFICE/4.jpg", title: "DENTIST_OFFICE" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/03_DENTIST_OFFICE/5.jpg", title: "DENTIST_OFFICE" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/03_DENTIST_OFFICE/6.jpg", title: "DENTIST_OFFICE" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/03_DENTIST_OFFICE/7.jpg", title: "DENTIST_OFFICE" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/03_DENTIST_OFFICE/8.jpg", title: "DENTIST_OFFICE" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/03_DENTIST_OFFICE/9.jpg", title: "DENTIST_OFFICE" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/03_DENTIST_OFFICE/10.jpg", title: "DENTIST_OFFICE" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/03_DENTIST_OFFICE/11.jpg", title: "DENTIST_OFFICE" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/03_DENTIST_OFFICE/12.jpg", title: "DENTIST_OFFICE" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/03_DENTIST_OFFICE/13.jpg", title: "DENTIST_OFFICE" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/03_DENTIST_OFFICE/14.jpg", title: "DENTIST_OFFICE" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/03_DENTIST_OFFICE/15.jpg", title: "DENTIST_OFFICE" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/03_DENTIST_OFFICE/16.jpg", title: "DENTIST_OFFICE" }
    ],
  },
  { clickable: true,
    src:  "/SITE_PROJECTS/03_COMMERCIAL/04_HEARTCORE_GYM/HEARTCORE_2.jpg",
    title: "Pilates Studio",
    redirect: "pilates_studio",
    category: 'Commercial',
    description: [`pilates_studio` ],
    location: 'Ilisia_athens',
    info: 'Ilisia_athens_info',
    images: [
      { src: "/SITE_PROJECTS/03_COMMERCIAL/04_HEARTCORE_GYM/HEARTCORE_1.jpg", title: "heartcore_gym" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/04_HEARTCORE_GYM/HEARTCORE_2.jpg", title: "heartcore_gym" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/04_HEARTCORE_GYM/HEARTCORE_3.jpg", title: "heartcore_gym" }
    ],
  },
  { clickable: true,
    src:  "/SITE_PROJECTS/03_COMMERCIAL/05_Heartcore_Training_Place/01.jpg",
    title: "Heartcore Training Place",
    redirect: "Heartcore_Training_Place",
    category: 'Commercial',
    description: [`Heartcore_Training_Place_desc1`,`Heartcore_Training_Place_desc2`,`Heartcore_Training_Place_desc3`,`Heartcore_Training_Place_desc4` ],
    location: 'Ilisia_athens',
    info: 'Heartcore_Training_Place_info',
    images: [
      { src: "/SITE_PROJECTS/03_COMMERCIAL/05_Heartcore_Training_Place/01.jpg", title: "Heartcore_Training_Place" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/05_Heartcore_Training_Place/02.jpg", title: "Heartcore_Training_Place" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/05_Heartcore_Training_Place/03.jpg", title: "Heartcore_Training_Place" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/05_Heartcore_Training_Place/04.jpg", title: "Heartcore_Training_Place" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/05_Heartcore_Training_Place/05.jpg", title: "Heartcore_Training_Place" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/05_Heartcore_Training_Place/06.jpg", title: "Heartcore_Training_Place" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/05_Heartcore_Training_Place/07.jpg", title: "Heartcore_Training_Place" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/05_Heartcore_Training_Place/08.jpg", title: "Heartcore_Training_Place" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/05_Heartcore_Training_Place/09.jpg", title: "Heartcore_Training_Place" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/05_Heartcore_Training_Place/10.jpg", title: "Heartcore_Training_Place" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/05_Heartcore_Training_Place/11.jpg", title: "Heartcore_Training_Place" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/05_Heartcore_Training_Place/12.jpg", title: "Heartcore_Training_Place" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/05_Heartcore_Training_Place/13.jpg", title: "Heartcore_Training_Place" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/05_Heartcore_Training_Place/14.jpg", title: "Heartcore_Training_Place" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/05_Heartcore_Training_Place/15.jpg", title: "Heartcore_Training_Place" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/05_Heartcore_Training_Place/16.jpg", title: "Heartcore_Training_Place" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/05_Heartcore_Training_Place/17.jpg", title: "Heartcore_Training_Place" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/05_Heartcore_Training_Place/18.jpg", title: "Heartcore_Training_Place" },
      { src: "/SITE_PROJECTS/03_COMMERCIAL/05_Heartcore_Training_Place/19.jpg", title: "Heartcore_Training_Place" },
    ],
  },
  { clickable: true,
    src:  "/SITE_PROJECTS/01_RESIDENTIAL/11_TREE_HOUSE/01.jpg",
    title: "TreeHouse",
    redirect: "tree_house",
    category: 'Residential',
    description: [`tree_house_desc1`,`tree_house_desc2`,`tree_house_desc3`,`tree_house_desc4` ],
    location: 'kerkira_town',
    info: 'tree_house_info',
    images: [
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/11_TREE_HOUSE/01.jpg", title: "TreeHouse" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/11_TREE_HOUSE/02.jpg", title: "TreeHouse" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/11_TREE_HOUSE/03.jpg", title: "TreeHouse" },
      { src: "/SITE_PROJECTS/01_RESIDENTIAL/11_TREE_HOUSE/04.jpg", title: "TreeHouse" }
    ],
  },
  { 
    clickable: true,
    src: "/new_projects/01_VHF_VISIONARY/001.jpg",
    title: "VHF Visionary Heritage Faculty",
    redirect: "VHF_Visionary_Heritage_Faculty",
    category: 'Commercial',
    description: ['VHF_desc1', 'VHF_desc2', 'VHF_desc3', 'VHF_desc4', 'VHF_desc5'],
    location: 'Chios_greece',
    info: 'VHF_info',
    images: [
      { src: "/new_projects/01_VHF_VISIONARY/001.jpg", title: "VHF_Visionary" },
      { src: "/new_projects/01_VHF_VISIONARY/002.jpg", title: "VHF_Visionary" },
      { src: "/new_projects/01_VHF_VISIONARY/003.jpg", title: "VHF_Visionary" },
      { src: "/new_projects/01_VHF_VISIONARY/004.jpg", title: "VHF_Visionary" },
      { src: "/new_projects/01_VHF_VISIONARY/005.jpg", title: "VHF_Visionary" },
      { src: "/new_projects/01_VHF_VISIONARY/006.jpg", title: "VHF_Visionary" },
      { src: "/new_projects/01_VHF_VISIONARY/007.jpg", title: "VHF_Visionary" },
      { src: "/new_projects/01_VHF_VISIONARY/008.jpg", title: "VHF_Visionary" },
      { src: "/new_projects/01_VHF_VISIONARY/009.jpg", title: "VHF_Visionary" },
      { src: "/new_projects/01_VHF_VISIONARY/010.jpg", title: "VHF_Visionary" },
      { src: "/new_projects/01_VHF_VISIONARY/011.jpg", title: "VHF_Visionary" },
      { src: "/new_projects/01_VHF_VISIONARY/012.jpg", title: "VHF_Visionary" }
    ],
  },
  { 
    clickable: true,
    src: "/new_projects/02_SOMA_PILATES/000_cover.jpg",
    title: "SOMA Pilates Hub",
    redirect: "SOMA_Pilates_Hub",
    category: 'Commercial',
    description: ['SOMA_desc1', 'SOMA_desc2', 'SOMA_desc3'],
    location: 'Palaio_faliro_athens',
    info: 'SOMA_info',
    photoBy: "Spatial Architecture + Design",
    images: [
      { src: "/new_projects/02_SOMA_PILATES/000_cover.jpg", title: "SOMA_Pilates" },
      { src: "/new_projects/02_SOMA_PILATES/001.jpg", title: "SOMA_Pilates" },
      { src: "/new_projects/02_SOMA_PILATES/002.jpg", title: "SOMA_Pilates" },
      { src: "/new_projects/02_SOMA_PILATES/003.jpg", title: "SOMA_Pilates" },
      { src: "/new_projects/02_SOMA_PILATES/004.jpg", title: "SOMA_Pilates" },
      { src: "/new_projects/02_SOMA_PILATES/005.jpg", title: "SOMA_Pilates" },
      { src: "/new_projects/02_SOMA_PILATES/006.jpg", title: "SOMA_Pilates" },
      { src: "/new_projects/02_SOMA_PILATES/007.jpg", title: "SOMA_Pilates" },
      { src: "/new_projects/02_SOMA_PILATES/008.jpg", title: "SOMA_Pilates" },
      { src: "/new_projects/02_SOMA_PILATES/009.jpg", title: "SOMA_Pilates" },
      { src: "/new_projects/02_SOMA_PILATES/010.jpg", title: "SOMA_Pilates" },
      { src: "/new_projects/02_SOMA_PILATES/011.jpg", title: "SOMA_Pilates" },
      { src: "/new_projects/02_SOMA_PILATES/012.jpg", title: "SOMA_Pilates" },
      { src: "/new_projects/02_SOMA_PILATES/013.jpg", title: "SOMA_Pilates" },
      { src: "/new_projects/02_SOMA_PILATES/014.jpg", title: "SOMA_Pilates" }
    ],
  },
  { 
    clickable: true,
    src: "/new_projects/03_DIAMERISMA/001.jpg",
    title: "Papagou Apartment",
    redirect: "Papagou_Apartment",
    category: 'Residential',
    description: ['Papagou_desc1', 'Papagou_desc2', 'Papagou_desc3'],
    location: 'Papagou_athens',
    info: 'Papagou_info',
    images: [
      { src: "/new_projects/03_DIAMERISMA/001.jpg", title: "Papagou_Apartment" },
      { src: "/new_projects/03_DIAMERISMA/002.jpg", title: "Papagou_Apartment" },
      { src: "/new_projects/03_DIAMERISMA/003.jpg", title: "Papagou_Apartment" },
      { src: "/new_projects/03_DIAMERISMA/004.jpg", title: "Papagou_Apartment" },
      { src: "/new_projects/03_DIAMERISMA/005.jpg", title: "Papagou_Apartment" },
      { src: "/new_projects/03_DIAMERISMA/006.jpg", title: "Papagou_Apartment" },
      { src: "/new_projects/03_DIAMERISMA/007.jpg", title: "Papagou_Apartment" },
      { src: "/new_projects/03_DIAMERISMA/008.jpg", title: "Papagou_Apartment" }
    ],
  },
  { 
    clickable: true,
    src: "/new_projects/04_CORE_X/p01.jpg",
    title: "CORE X",
    redirect: "CORE_X",
    category: 'Commercial',
    description: ['CORE_X_desc1', 'CORE_X_desc2'],
    location: 'Ano_patisia_athens',
    info: 'CORE_X_info',
    photoBy: "Spatial Architecture + Design",
    images: [
      { src: "/new_projects/04_CORE_X/p01.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/p02.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/p03.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/p04.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/p05.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/p06.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/p07.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/p08.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/p09.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/p10.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/p11.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/p12.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/p13.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/p14.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/p15.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/p16.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/p17.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/p18.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/p19.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/p20.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/r01.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/r02.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/r03.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/r04.jpg", title: "CORE_X" },
      { src: "/new_projects/04_CORE_X/r05.jpg", title: "CORE_X" }
    ],
  },
  { 
    clickable: true,
    src: "/new_projects/05_PHAROS/001.jpg",
    title: "Sidero_Lighthouse",
    redirect: "Sidero_Lighthouse_Restoration",
    category: 'Commercial',
    description: ['Faros_desc1', 'Faros_desc2'],
    location: 'Old_fortress_corfu',
    info: 'Faros_info',
    images: [
      { src: "/new_projects/05_PHAROS/001.jpg", title: "Faros" },
      { src: "/new_projects/05_PHAROS/002.jpg", title: "Faros" },
      { src: "/new_projects/05_PHAROS/003.jpg", title: "Faros" },
      { src: "/new_projects/05_PHAROS/004.jpg", title: "Faros" }
    ],
  },
  { 
    clickable: true,
    src: "/new_projects/06_COEXISTING/001.jpg",
    title: "Coexisting",
    redirect: "Coexisting",
    category: 'Residential',
    description: ['Coexisting_desc1', 'Coexisting_desc2', 'Coexisting_desc3', 'Coexisting_desc4'],
    location: 'Chania_crete',
    info: 'Coexisting_info',
    images: [
      { src: "/new_projects/06_COEXISTING/001.jpg", title: "Coexisting" },
      { src: "/new_projects/06_COEXISTING/002.jpg", title: "Coexisting" },
      { src: "/new_projects/06_COEXISTING/MASTERPLAN_DWMATA.jpg", title: "Coexisting" },
      { src: "/new_projects/06_COEXISTING/MASTERPLAN_ISOGEIO.jpg", title: "Coexisting" },
      { src: "/new_projects/06_COEXISTING/MASTERPLAN_OROFOS.jpg", title: "Coexisting" }
    ],
  },
  { 
    clickable: true,
    src: "/new_projects/07_KENDALL/01.jpg",
    title: "Kendall Road Tavern",
    redirect: "Kendall_Road_Tavern",
    category: 'Commercial',
    description: ['Kendall_desc1', 'Kendall_desc2', 'Kendall_desc3', 'Kendall_desc4'],
    location: 'Tyngsboro_MA',
    info: 'Kendall_info',
    images: [
      { src: "/new_projects/07_KENDALL/01.jpg", title: "Kendall" },
      { src: "/new_projects/07_KENDALL/02.jpg", title: "Kendall" },
      { src: "/new_projects/07_KENDALL/03.jpg", title: "Kendall" },
      { src: "/new_projects/07_KENDALL/04.jpg", title: "Kendall" }
    ],
  },
  { 
    clickable: true,
    src: "/new_projects/08_VILLA_B/01.jpg",
    title: "Villa B",
    redirect: "Villa_B",
    category: 'Residential',
    description: ['Villa_B_desc1', 'Villa_B_desc2', 'Villa_B_desc3', 'Villa_B_desc4', 'Villa_B_desc5', 'Villa_B_desc6'],
    location: 'Seladia_paros',
    info: 'Villa_B_info',
    images: [
      { src: "/new_projects/08_VILLA_B/01.jpg", title: "Villa_B" },
      { src: "/new_projects/08_VILLA_B/02.jpg", title: "Villa_B" },
      { src: "/new_projects/08_VILLA_B/03.jpg", title: "Villa_B" },
      { src: "/new_projects/08_VILLA_B/04.jpg", title: "Villa_B" },
      { src: "/new_projects/08_VILLA_B/05.jpg", title: "Villa_B" },
      { src: "/new_projects/08_VILLA_B/06.jpg", title: "Villa_B" },
      { src: "/new_projects/08_VILLA_B/07.jpg", title: "Villa_B" },
      { src: "/new_projects/08_VILLA_B/08.jpg", title: "Villa_B" },
      { src: "/new_projects/08_VILLA_B/09.jpg", title: "Villa_B" },
      { src: "/new_projects/08_VILLA_B/10.jpg", title: "Villa_B" },
      { src: "/new_projects/08_VILLA_B/11.jpg", title: "Villa_B" }
    ],
  },
  {
    clickable: true,
    src: "/new_projects/09_PARK_OFFICES/001.jpg",
    title: "Park Offices",
    redirect: "Park_Offices",
    category: 'Commercial',
    description: ['Park_Offices_desc1'],
    location: 'Tyngsboro_MA',
    info: 'Park_Offices_info',
    images: [
      { src: "/new_projects/09_PARK_OFFICES/001.jpg", title: "Park_Offices" },
      { src: "/new_projects/09_PARK_OFFICES/002.jpg", title: "Park_Offices" },
      { src: "/new_projects/09_PARK_OFFICES/003.jpg", title: "Park_Offices" },
      { src: "/new_projects/09_PARK_OFFICES/004.jpg", title: "Park_Offices" }
    ],
  },
  {
    clickable: true,
    src: "/new_projects/10_BED_BREAKFAST_BREEZE/001.jpg",
    title: "Bed, Breakfast, Breeze",
    redirect: "Bed_Breakfast_Breeze",
    category: 'Hospitality',
    description: ['BBB_desc1', 'BBB_desc2', 'BBB_desc3', 'BBB_desc4', 'BBB_desc5'],
    location: 'Krestena_ilia',
    info: 'BBB_info',
    images: [
      { src: "/new_projects/10_BED_BREAKFAST_BREEZE/001.jpg", title: "Bed_Breakfast_Breeze" },
      { src: "/new_projects/10_BED_BREAKFAST_BREEZE/002.jpg", title: "Bed_Breakfast_Breeze" },
      { src: "/new_projects/10_BED_BREAKFAST_BREEZE/003.jpg", title: "Bed_Breakfast_Breeze" },
      { src: "/new_projects/10_BED_BREAKFAST_BREEZE/004.jpg", title: "Bed_Breakfast_Breeze" },
      { src: "/new_projects/10_BED_BREAKFAST_BREEZE/006.jpg", title: "Bed_Breakfast_Breeze" },
      { src: "/new_projects/10_BED_BREAKFAST_BREEZE/007.jpg", title: "Bed_Breakfast_Breeze" }
    ],
  },
  {
    clickable: true,
    src: "/new_projects/11_PEFKI_APARTMENT/001.jpg",
    title: "Pefki Apartment",
    redirect: "Pefki_Apartment",
    category: 'Residential',
    description: ['Pefki_desc1', 'Pefki_desc2'],
    location: 'Pefki_athens',
    info: 'Pefki_info',
    images: [
      { src: "/new_projects/11_PEFKI_APARTMENT/001.jpg", title: "Pefki_Apartment" },
      { src: "/new_projects/11_PEFKI_APARTMENT/002.jpg", title: "Pefki_Apartment" },
      { src: "/new_projects/11_PEFKI_APARTMENT/003.jpg", title: "Pefki_Apartment" },
      { src: "/new_projects/11_PEFKI_APARTMENT/004.jpg", title: "Pefki_Apartment" },
      { src: "/new_projects/11_PEFKI_APARTMENT/005.jpg", title: "Pefki_Apartment" },
      { src: "/new_projects/11_PEFKI_APARTMENT/006.jpg", title: "Pefki_Apartment" }
    ],
  }
];

// Display order requested by the client (email 03/09).
// Projects listed here appear first, in this exact order; anything not listed keeps its
// original relative position afterwards, and the demoted list is pinned to the end.
// This ordering applies to the "All" view and to every category section, because the
// section tabs filter this same array.
const PROMOTED_ORDER = [
  'VHF_Visionary_Heritage_Faculty',
  'Heartcore_Training_Place',
  'Coexisting',
  'Papagou_Apartment',
  'CORFU_ATTIC',
];

const DEMOTED_ORDER = [
  'Villa_round',
  'Vatos',
  'Concept_Villa_01',
  'Concept_Villa_02',
  'pilates_studio',
];

const orderedProjects = [
  ...PROMOTED_ORDER.map((id) => projectsData.find((p) => p.redirect === id)).filter(Boolean),
  ...projectsData.filter(
    (p) => !PROMOTED_ORDER.includes(p.redirect) && !DEMOTED_ORDER.includes(p.redirect)
  ),
  ...DEMOTED_ORDER.map((id) => projectsData.find((p) => p.redirect === id)).filter(Boolean),
];

export default orderedProjects;
